import { BondPriceNominal } from "@goodfill/domain-properties/src";
import React from "react";

export const formatPrice = (props: { value: BondPriceNominal }) => props.value.mul(100).toFixed(2);

export const BondPriceComponent = (props: { value: BondPriceNominal }) => <>{formatPrice(props)}</>;
